<template>
	<b-modal :no-close-on-backdrop="isLoading" :hide-header-close="isLoading" ref="modal" :title="title" :size="modalSize" class="modal-primary editHotelHrambaModal" @hidden="clearModalData">
		<loading :active.sync="isLoading" 
			:is-full-page="false"></loading>
		<b-row v-show="mode === mode_ADDING1 || mode === mode_EDITING2">
			<b-col>
				<b-row>
					<b-col>
						<b-form-radio-group v-model="hotelStranka.external" class="mb-3" buttons button-variant="outline-primary">
							<b-form-radio :value=1>External</b-form-radio>
							<b-form-radio :value=0>Internal</b-form-radio>
						</b-form-radio-group>
					</b-col>
					<b-col>
						<b-form-radio-group v-model="hotelStranka.is_company" class="mb-3" buttons button-variant="outline-primary">
							<b-form-radio :value=0>Fizična oseba</b-form-radio>
							<b-form-radio :value=1>Podjetje</b-form-radio>
						</b-form-radio-group>
					</b-col>
				</b-row>
				<b-row>
				</b-row>
				<b-row v-if="hotelStranka.is_company">
					<b-col>
						<b-form-group label="Naziv:"
							label-for="kupec_title"
							:invalid-feedback="invalidFeedback_title"
							:state="state_title">
							<b-form-input id="kupec_title"
								type="text"
								v-model="hotelStranka.title"
								placeholder="Naziv stranke"></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row v-else>
					<b-col>
						<b-form-group label="Ime:"
							label-for="kupec_ime"
							:invalid-feedback="invalidFeedback_first_name"
							:state="state_first_name">
							<b-form-input id="kupec_ime"
								type="text"
								v-model="hotelStranka.first_name"
								placeholder="Ime stranke"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col>
						<b-form-group label="Priimek:" 
							label-for="kupec_priimek"
							:invalid-feedback="invalidFeedback_last_name"
							:state="state_last_name">
							<b-form-input id="kupec_priimek"
								type="text"
								v-model="hotelStranka.last_name"
								placeholder="Priimek stranke"></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-form-group label="Email:"
							label-for="kupec_email"
							:invalid-feedback="invalidFeedback_email"
							:state="state_email">
							<b-form-input id="kupec_email"
								type="text"
								v-model="hotelStranka.email"
								placeholder="Elektronski naslov stranke"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col>
						<b-form-group label="Telefonska številka:" 
							label-for="kupec_telefon">
							<b-form-input id="kupec_telefon"
								type="text"
								v-model="hotelStranka.phone_number"
								placeholder="Telefonska številka stranke"></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-form-group
							label-for="input-vehicle"
							label="Vozilo:">
								<b-form-input 
								v-model="hotelStranka.vehicle" id="input-vehicle" placeholder="Naziv vozila" ></b-form-input>
						</b-form-group>
					</b-col>
					<b-col>
						<b-form-group
							label-for="input-registration_number"
							:invalid-feedback="invalidFeedback_registration_number"
							:state="state_registration_number"
							label="Registrska številka:">
								<b-form-input v-on:keyup="formatRegistrationNumber"
								v-model="hotelStranka.registration_number" id="input-registration_number" placeholder="Registrska številka" ></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
		<div v-if="mode === mode_UNKNOWN0">
			Neznan način
		</div>
		<b-alert :variant="message.type" :show="message.text && message.text !== ''">{{ message.text }}</b-alert>
		<template slot="modal-footer" slot-scope="{ cancel }">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="end" class="ma_pos">
						<b-button :disabled="isLoading" style="margin-right:5px;" variant="secondary" @click="cancel()">Prekliči</b-button>
						<b-button :disabled="okButton.disabled" variant="primary" @click.stop="onOkModal()">{{ okButton.label }}
							<b-spinner small v-if="okButton.progress"></b-spinner>
						</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
	</b-modal>
</template>

<script>
import service from '@/service';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
// import _ from 'lodash';

export default {
	name: 'edit-hotel-stranka-modal',
	components: {
		Loading
	},
	props: {
	},
	methods: {
		showModal: function (modalData) {
			/*
				mode 1 => Dodajanje novega
				mode 2 => Urejanje
			*/
			this.mode = modalData.mode;
			this.initModal(modalData.hotelStranka);
		},
		initModal: function (hotelStranka) {
			if (this.mode === this.mode_ADDING1) {
				this.title = 'Dodajanje nove stranke';
				this.okButton.label = 'Dodaj';
			} else if (this.mode === this.mode_EDITING2) {
				this.title = 'Urejanje stranke št. '; //  + hotelStranka.id;
				this.hotelStranka = this.initHotelStranka(hotelStranka);
				this.okButton.label = 'Shrani';
			} else {
				this.title = 'Neznan način';
				this.mode = this.mode_UNKNOWN0;
				this.okButton.label = 'Zapri';
			}
			this.$refs.modal.show();
		},
		initHotelStranka: function (hotelStranka) {
			return {
				id: hotelStranka.id,
				first_name: hotelStranka.first_name,
				last_name: hotelStranka.last_name,
				title: hotelStranka.title,
				address: hotelStranka.address,
				city: hotelStranka.city,
				email: hotelStranka.email,
				phone_number: hotelStranka.phone_number,
				registration_number: hotelStranka.registration_number,
				vehicle: hotelStranka.vehicle,
				external: hotelStranka.external,
				is_company: hotelStranka.is_company
			};
		},
		onOkModal: function () {
			if (this.formDisabled) {
				this.$refs.modal.hide();
			} else if (this.validateForm) {
				this.startProgress();
				this.showAlert();
				service.hotelStrankaEdit(this.hotelStranka)
					.then(responseData => {
						if (responseData.message === 'edited' || responseData.message === 'added') {
							this.$emit('emit_success', responseData.hotelStranka, this.mode);
							this.$refs.modal.hide();
						} else {
							this.showAlert('Neveljaven odziv strežnika!', this.ALERT_TYPE_ERROR);
							console.error('Neveljaven response message: ' + responseData.message);
						}
						this.stopProgress();
					})
					.catch(error => {
						this.stopProgress();
						if (error.response) {
						// Request made and server responded
							if (error.response.status === 400) {
								if (error.response.data.internalCode === 600) {
									this.showAlert('Neznana napaka na strežniku!', this.ALERT_TYPE_ERROR);
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 601) {
									this.showAlert('Napaka pri podatkovni bazi!', this.ALERT_TYPE_ERROR);
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 602) {
									this.showAlert('Uporabnik nima dostopa do hotela gum!', this.ALERT_TYPE_ERROR);
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 603) {
									this.showAlert('Napaka pri validaciji na strežniku!', this.ALERT_TYPE_ERROR);
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 604) {
									this.showAlert('Hramba ni najdena!', this.ALERT_TYPE_ERROR);
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 605) {
									this.showAlert('Neuspešno shranjevanje hrambe!', this.ALERT_TYPE_ERROR);
									console.error(error.response.data.message);
								} else {
									this.showAlert('Neznana napaka na strežniku (status: ' + error.response.status + ')!', this.ALERT_TYPE_ERROR);
									console.error(error.response.data.internalCode, error.response.data.message);
								}
							} else {
								this.showAlert('Neznana napaka na strežniku (status: ' + error.response.status + ')!', this.ALERT_TYPE_ERROR);
								console.error(error.response.status, error.response.data.message);
							}
						} else if (error.request) {
							// The request was made but no response was received
							this.showAlert('Napaka: strežnik se ni odzval!', this.ALERT_TYPE_ERROR);
							console.error('The request was made but no response was received:', error.request);
						} else {
							// Something happened in setting up the request that triggered an Error
							this.showAlert('Napaka pri pošiljanju zahteve na strežnik!', this.ALERT_TYPE_ERROR);
							console.error('Something happened in setting up the request that triggered an Error:', error.message);
						}
					});
			} else {
				this.showAlert('Nepravilno izpolnjen obrazec!', this.ALERT_TYPE_ERROR);
				this.stopProgress();
			}
		},
		hotelStrankaButton_click: function () {
			console.log('ok')
		},
		clearModalData: function () {
			this.title = '';
			this.stopProgress();
			this.showAlert();
			this.okButton.label = '';
			this.mode = this.mode_UNKNOWN0;
			this.hotelStranka = {
				id: 0,
				first_name: null,
				last_name: null,
				title: null,
				email: null,
				phone_number: null,
				address: null,
				city: null,
				registration_number: null,
				vehicle: null,
				external: 1,
				is_company: 0
			};
		},
		startProgress: function () {
			this.isLoading = true;
			this.okButton.disabled = true;
			this.okButton.progress = true;
		},
		stopProgress: function () {
			this.isLoading = false;
			this.okButton.disabled = false;
			this.okButton.progress = false;
		},
		showAlert: function (message, type, seconds) {
			if (message && type && seconds) {
				this.message.type = type;
				this.message.text = message;
				setTimeout(() => {
					this.showAlert();
				}, seconds * 1000);
			} else if (message && type) {
				this.message.type = type;
				this.message.text = message;
			} else if (message) {
				this.message.type = 'primary';
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		formatRegistrationNumber: function () {
			this.hotelStranka.registration_number = this.hotelStranka.registration_number.replace(' ', '');
			this.hotelStranka.registration_number = this.hotelStranka.registration_number.replace('-', '');
			if (this.hotelStranka.registration_number.length > 9) {
				this.hotelStranka.registration_number = this.hotelStranka.registration_number.substring(0, 10);
			}
		}
	},
	data: function () {
		return {
			isLoading: false,
			title: '',
			okButton: {
				label: '',
				progress: false,
				disabled: false
			},
			message: {
				type: null,
				text: null
			},
			ALERT_TYPE_SUCCESS: 'success',
			ALERT_TYPE_ERROR: 'danger',
			mode_UNKNOWN0: 0,
			mode_ADDING1: 1,
			mode_EDITING2: 2,
			mode: 0,
			hotelStranka: {
				id: 0,
				first_name: '',
				last_name: '',
				title: '',
				email: '',
				phone_number: '',
				address: '',
				city: '',
				registration_number: '',
				vehicle: '',
				external: 1,
				is_company: 0
			}
		}
	},
	watch: {
	},
	computed: {
		state_first_name () {
			if ((this.hotelStranka.first_name && this.hotelStranka.first_name.length > 0) || this.hotelStranka.is_company === 1) {
				return true;
			}
			return false;
		},
		invalidFeedback_first_name () {
			if (this.hotelStranka.first_name || this.hotelStranka.is_company === 1) {
				this.showAlert();
				return '';
			}
			return 'Ime je obvezno';
		},
		state_last_name () {
			if ((this.hotelStranka.last_name && this.hotelStranka.last_name.length > 0) || this.hotelStranka.is_company === 1) {
				return true;
			}
			return false;
		},
		invalidFeedback_last_name () {
			if (this.hotelStranka.last_name || this.hotelStranka.is_company === 1) {
				this.showAlert();
				return '';
			}
			return 'Priimek je obvezen';
		},
		state_title () {
			if ((this.hotelStranka.title && this.hotelStranka.title.length > 0) || this.hotelStranka.is_company === 0) {
				return true;
			}
			return false;
		},
		invalidFeedback_title () {
			if (this.hotelStranka.title || this.hotelStranka.is_company === 0) {
				this.showAlert();
				return '';
			}
			return 'Naziv je obvezen';
		},
		state_email () {
			let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if (!this.hotelStranka.email || this.hotelStranka.email.length < 1 || emailRegex.test(this.hotelStranka.email)) {
				return true;
			}
			return false;
		},
		invalidFeedback_email () {
			let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if (this.hotelStranka.email && this.hotelStranka.email.length > 0 && !emailRegex.test(this.hotelStranka.email)) {
				return 'Nepravilna oblika emaila';
			}
			// this.showAlert();
			return '';
		},
		state_registration_number () {
			if (!this.hotelStranka.registration_number || (this.hotelStranka.registration_number && this.hotelStranka.registration_number.length < 11)) {
				return true;
			}
			return false;
		},
		invalidFeedback_registration_number () {
			if (!this.hotelStranka.registration_number || (this.hotelStranka.registration_number && this.hotelStranka.registration_number.length >= 10)) {
				return 'Največ 10 znakov';
			}
			// this.showAlert();
			return '';
		},
		validateForm: function () {
			if (this.state_first_name && this.state_last_name && this.state_title && this.state_email && this.state_registration_number) {
				return true;
			}
			return false;
		},
		formDisabled: function () {
			return false;
		},
		modalSize () {
			if (this.mode === this.mode_ADDING1 || this.mode === this.mode_EDITING2) {
				return 'md';
			}
			return '';
		}
	},
	created () {
	}
}
</script>

<style scoped>
@import '../../../../node_modules/ladda/dist/ladda-themeless.min.css';
.ma_pos {
	text-align: end;
}
.nav {
	border-top: 1px solid #c8ced3;
	padding-top: 1rem;
}
.pagination {
	margin-left: 1rem;
	margin-right: 1rem;
}
.page-link.rows_total {
	text-align: center;
	border-radius: 5px;
	width: 120px;
}
.externalLabel {
	margin-top: 1.75rem;
}
</style>
<style>
.seznamHotelStoritveIconStyle {
	min-width: 35px;
}
.tdHotelStoritveActions {
	width: 200px;
	max-width: 200px;
	padding: 2px !important;
	text-align: end;
}
.tdHotelStoritveStatus {
	width: 70px;
}
.tdHotelStoritveDatum {
	width: 160px;
}
.tdHotelStoritveLetnik {
	width: 100px;
}
.tdHotelStoritveStGum {
	width: 100px;
}
.tdHotelStoritveId {
	width: 50px;
}
@media (min-width: 992px) { .modal .modal-huge { max-width: 90% !important; width: 90% !important;; } }
</style>


// WEBPACK FOOTER //
// src/components/HotelGum/Modals/EditHotelStrankaModal.vue